import { Skeleton } from "../ui/skeleton";
import AutoStackTransactionHistorySkeleton from "./AutoStackTransactionHistorySkeleton";

export default function SingleAutoStackSkeleton() {
  return (
    <div className="px-6 md:px-14 py-6 bg-bg-light-gray rounded-t-2xl space-y-8 h-[calc(100vh-100px)]">
      <div className="flex flex-wrap md:flex-nowrap items-stretch gap-6 w-full">
        <div className="w-full md:w-1/2 flex">
          <div className="bg-white rounded-lg p-6 space-y-6 w-full">
            <div className="flex items-center justify-between gap-2">
              <div className="flex items-center gap-3">
                <Skeleton className="h-8 w-8 rounded-full bg-gray-300" />
                <Skeleton className="h-6 w-48 bg-gray-300" />
              </div>
              <Skeleton className="h-8 w-24 rounded-full bg-gray-300" />
            </div>

            <div className="flex flex-col space-y-4">
              <div className="flex items-center gap-1 mb-2">
                <Skeleton className="w-6 h-6 rounded-full bg-gray-300" />
                <Skeleton className="h-4 w-20 bg-gray-300" />
              </div>

              <div className="space-y-2">
                <Skeleton className="h-3 w-24 bg-gray-300" />
                <Skeleton className="h-8 w-32 bg-gray-300" />
                <div className="flex items-center gap-2">
                  <Skeleton className="h-4 w-16 bg-gray-300" />
                  <Skeleton className="h-4 w-12 bg-gray-300" />
                </div>
              </div>

              {/* Additional Metrics */}
              <div className="grid grid-cols-2 gap-4 pt-4">
                <div className="space-y-2">
                  <Skeleton className="h-3 w-20 bg-gray-300" />
                  <Skeleton className="h-5 w-24 bg-gray-300" />
                </div>
                <div className="space-y-2">
                  <Skeleton className="h-3 w-20 bg-gray-300" />
                  <Skeleton className="h-5 w-24 bg-gray-300" />
                </div>
              </div>
            </div>

            <Skeleton className="h-80 w-full rounded-lg bg-gray-300" />
          </div>
        </div>
        <div className="w-full md:w-1/2 flex">
          <AutoStackTransactionHistorySkeleton />
        </div>
      </div>
    </div>
  );
}
